import React, { useEffect, useState } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import { gatepassList, gatepassUpdata } from '../../../api/GatePassService';
import { viewlist } from '../../../api/BatchService';
import { StudentList } from '../../../api/StudentServices';
import Swal from 'sweetalert2';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { enquiryList } from '../../../api/Enquiry';

export default function GatePassupdata() {
    const navigate = useNavigate();
    const location = useLocation();
    const passedId = location.state?.id;
    const [studentType, setStudentType] = useState('');
    const [batches, setBatches] = useState([]);
    const [students, setStudents] = useState([]);
    const [enquiries, setEnquiries] = useState([]);
    const [formData, setFormData] = useState({
        type: '',
        batch_id: '',
        student_id: '',
        enquiry_id: '',
        reason: '',
        time: '',
        date: ''
    });

    const handleTypeChange = (e) => {
        setStudentType(e.target.value);
        setFormData({ ...formData, type: e.target.value });
    };

    const fetchGatePass = async () => {
        try {
            const response = await gatepassList(passedId);
            const data = response?.data?.data?.data?.[0];
            if (data) {
                setFormData({
                    type: data.type?.toString() || '',
                    batch_id: data.batch_id || '',
                    student_id: data.student_id || '',
                    enquiry_id: data.enquiry_id || '',
                    reason: data.reason || '',
                    time: data.time || '',
                    date: data.date || ''
                });
                setStudentType(data.type?.toString() || '');
            }
        } catch {
            Swal.fire('Error', 'Failed to fetch gate pass data.', 'error');
        }
    };

    const fetchBatches = async () => {
        const res = await viewlist();
        setBatches(res?.data?.batches || []);
    };

    const fetchStudents = async () => {
        const res = await StudentList();
        setStudents(res.data.data.data || []);
    };

    const fetchEnquiries = async () => {
        const res = await enquiryList();
        setEnquiries(res.data.data.data || []);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { id: passedId, ...formData };
            const response = await gatepassUpdata(payload);

            if (response?.data?.status === true) {
                Swal.fire('Updated', response.data.message, 'success');
                navigate('/GatePass');
            }
        } catch {
            Swal.fire('Error', 'Failed to update gate pass.', 'error');
        }
    };

    useEffect(() => {
        fetchGatePass();
        fetchBatches();
        fetchStudents();
        fetchEnquiries();
    }, []);

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Header />
                <div className="layout-page">
                    <Nav />
                    <div className="content-wrapper">
                        <div className="container-fluid py-4">
                            <div className="card shadow p-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4 className="text-primary fw-bold">Update Gate Pass</h4>
                                    <Link
                                        to={"/GatePass"}
                                        className="btn btn-sm btn-outline-primary"
                                    >
                                        <i className="bi bi-arrow-left-circle me-1"></i> Back
                                    </Link>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="type"
                                                value={studentType}
                                                onChange={handleTypeChange}
                                                required
                                            >
                                                <option value="">Select Type</option>
                                                <option value="1">Admitted Students</option>
                                                <option value="0">Enquiry Students</option>
                                            </select>
                                            <label>Student Type</label>
                                        </div>

                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="batch_id"
                                                value={formData.batch_id}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Batch</option>
                                                {batches.map((batch) => (
                                                    <option key={batch.id} value={batch.id}>{batch.title}</option>
                                                ))}
                                            </select>
                                            <label>Batch</label>
                                        </div>

                                        <div className="col-md-4 form-floating form-floating-outline">
                                            {studentType === '1' && (
                                                <>
                                                    <select
                                                        className="form-select"
                                                        name="student_id"
                                                        value={formData.student_id}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Student</option>
                                                        {students.map((stu) => (
                                                            <option key={stu.id} value={stu.id}>{stu.name}</option>
                                                        ))}
                                                    </select>
                                                    <label>Student</label>
                                                </>
                                            )}

                                            {studentType === '0' && (
                                                <>
                                                    <select
                                                        className="form-select"
                                                        name="enquiry_id"
                                                        value={formData.enquiry_id}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Enquiry</option>
                                                        {enquiries.map((en) => (
                                                            <option key={en.id} value={en.id}>{en.name}</option>
                                                        ))}
                                                    </select>
                                                    <label>Enquiry Student</label>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row mb-3 mt-5">
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <textarea
                                                className="form-control input-uppercase"
                                                name="reason"
                                                value={formData.reason}
                                                onChange={handleChange}
                                                placeholder="Enter reason"
                                                required
                                            ></textarea>
                                            <label>Reason</label>
                                        </div>

                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <input
                                                type="time"
                                                className="form-control"
                                                name="time"
                                                value={formData.time}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label>Time</label>
                                        </div>
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label>Date</label>
                                        </div>
                                    </div>


                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Gate Pass</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
